export default {

    /** 共通エラー **/
    getAllErrors (state) {
        return state.allErrors
    },

    /** 共通リスト **/
    getListObj (state) {
        return state.listObj.data
    },
    getListObjLoadStatus (state) {
        return state.listObjLoadStatus
    },
    getListObjSeeMoreLoadStatus (state) {
        return state.listObjSeeMoreLoadStatus
    },
    getListItemDeleteStatus (state) {
        return state.listItemDeleteStatus
    },

    /** ユーザー情報 **/
    getUser(state) {
        return state.user
    },
    getRole(state) {
        return state.user.role
    },
    getUserLoadStatus (state) {
        return state.userLoadStatus
    },
    getRefreshArr (state) {
        return state.refreshArr
    },

    /** 個人情報取得 **/
    getPrivateInfo (state) {
        return state.privateInfo.data
    },
    getPrivateInfoLoadStatus (state) {
        return state.privateInfoLoadStatus
    },

    /** 郵便住所 **/
//    getAddressInfo (state) {
//        return state.addressInfo.data
//    },
//    getZipcodeErrors (state) {
//        return state.zipcodeErrors
//    },
//    getAddressInfoLoadStatus (state) {
//        return state.addressInfoLoadStatus
//    }


    /** カスタマイズシェアURL取得(案件・要員) **/
    getCustShareUrl (state) {
        return state.custShareUrl
    },
    getCustShareUrlLoadStatus (state) {
        return state.custShareUrlLoadStatus
    },

    /** Unique チェック **/
    getUniqueCheckErr (state) {
        return state.uniqueCheckErr
    },
    getUniqueCheckStatus (state) {
        return state.uniqueCheckStatus
    },

    /** selectGroup送信 **/
    getSendMailComStatus (state) {
        return state.sendMailComStatus
    },
    getSendMailComRes (state) {
        return state.sendMailComRes
    },

    /** 応募詳細メッセージ  **/
    getAddApplyHisMsg (state) {
        return state.addApplyHisMsg
    },
    getAddApplyHisMsgStatus (state) {
        return state.addApplyHisMsgStatus
    }
    
}
